import { useEffect } from "react";
import { useMutation, useQueryClient } from "react-query";
import { Auth } from "shared/@auth/Auth";
import { createContainer } from "unstated-next";

export function useLocalTicketCancelPut() {
  const queryClient = useQueryClient();
  const { makeAuthedRequest } = Auth.useContainer();

  const cancelTicketMutation = useMutation(
    async ({ orderId, ticketId }) => {
      const response = await makeAuthedRequest(
        `v1/events/order/local/ticket/cancel`,
        {
          method: "PUT",
          body: JSON.stringify({ orderId, ticketId }),
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 204 || response.status === 200) {
        return {
          message: "Ticket cancellation successful!",
          status: response.status,
        };
      } else if (response.status === 409) {
        return {
          message: "Error refunding ticket.",
          status: response.status,
        };
      } else {
        const errorText = await response.text();
        let errorMessage = "An error occurred. Please try again later.";

        try {
          const errorBody = JSON.parse(errorText);
          errorMessage = errorBody.error?.message?.message || errorMessage;
        } catch (e) {
          console.error("Failed to parse error response:", e);
        }

        return {
          message: errorMessage,
          status: response.status,
        };
      }
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries("orders");
      },
    }
  );

  return cancelTicketMutation;
}

export const CancelTicketContainer = createContainer(useLocalTicketCancelPut);
